import React from 'react'

export default props => {

  // header, body, footer
  const commonModal = ({ header, body, footer }) => (
    <div className='modal'>
      {header &&
      <div className='modal-header'>{header}</div>}
      <div className='modal-body'>{props.body}</div>
      <div className='modal-footer'>{props.footer}</div>
    </div>
  )

  return (
    <div className='modal-wrapper' style={props.style}>
      {props.children || commonModal(props)}
    </div>
  )
}
